/* eslint-env browser */

// Do not require files here unless we are enforcing that they stay slim as
// far as things brought in. Anything nontrivial in size, even something like
// moment, should not be brought in.

const wfConfig = require("./wfConfigs/phase2a");

const {initWebflow} = require("./WfUtil");

const setupEnroll = require("./WfEnrollUtil");

initWebflow(wfConfig);

document.addEventListener("DOMContentLoaded", function() {
	setupEnroll();
});
